import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { InputComponent } from '@bcef/ia-components/input';
import { ListboxModule } from '@bcef/ia-components/listbox';
import { PanelModule } from '@bcef/ia-components/panel';
import { RadioButtonModule } from '@bcef/ia-components/radio-button';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskConfig, NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { SuccessionFacade } from '@features/succession/succession.facade';
import { InvalidControlScrollDirective } from '@shared/directives/invalid-control-scroll.directive';

import { NotaryInformationFacade } from './notary-information.facade';

@DataLayered('dataLayer.notaryInformation')
@Component({
  selector: 'ia-succession-notary-information',
  templateUrl: './notary-information.component.html',
  imports: [
    AsyncPipe,
    ButtonModule,
    InputComponent,
    ListboxModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    TranslateModule,
    InvalidControlScrollDirective,
    PanelModule,
    RadioButtonModule,
  ],
  standalone: true,
  providers: [provideNgxMask()],
})
export class NotaryInformationComponent {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-mb-4 tw-mx-0 sm:tw-mx-24';

  protected readonly notaryInformationFacade = inject(NotaryInformationFacade);

  protected readonly successionFacade = inject(SuccessionFacade);

  public specialCharactersNotAllowed: NgxMaskConfig['patterns'] = {
    A: { pattern: new RegExp('[^:\'";()&<>*^\x00|]') },
  };

  protected listBoxOverlayConfig: OverlayConfig = {
    scrollStrategy: inject(Overlay).scrollStrategies.close(),
  };
}
